import i18n from '@/utils/i18n';

const fields =
  {
    plan: {
      title: i18n.t('form.plan'),
      items: [
        {
          name: "title",
          type: "text",
          required: true,
          label: i18n.t('form.title')
        },
        {
          name: "active",
          type: "switch",
          label: i18n.t('form.active'),
          title: i18n.t('global.yes'),
          titleFalse: i18n.t('global.no')
        },
        {
          name: "public",
          type: "switch",
          label: i18n.t('form.public'),
          title: i18n.t('global.yes'),
          titleFalse: i18n.t('global.no')
        },
        {
          name: "slug",
          type: "text",
          required: false,
          label: i18n.t('form.slug')
        },
        {
          name: "priority",
          type: "number",
          required: false,
          min: 0,
          label: i18n.t('form.priority'),
          tooltipName: "plan-priority",
          tooltipText: i18n.t('plan_tooltips.priority')
        },
        {
          name: "mailchimp_interests",
          label: "Mailchimp Interests",
          type: "select",
          storeGetter: 'data/mailchimp_interests',
          storeAction: 'data/fetchMailchimpInterests',
          options_url: 'mailchimp',
          required: false,
          allowEmpty: true,
          groupLabel: 'title',
          groupValues: 'interests',
          trackBy: 'title',
          labelKey: 'title',
          multiple: true
        },
        {
          name: "campaign_subcsr_interests",
          label: "CM Subscription Lists",
          type: "select",
          storeGetter: 'data/campaign_monitor_interests',
          storeAction: 'data/fetchCampaignMonitorInterests',
          required: false,
          allowEmpty: true,
          trackBy: 'list_id',
          dataNameKey: 'list_name',
          labelKey: 'list_name',
          multiple: true,
          visibleOnEmpty: false,
        },
        {
          name: "campaign_unsubcsr_interests",
          label: "CM Unsubscription Lists",
          type: "select",
          storeGetter: 'data/campaign_monitor_interests',
          storeAction: 'data/fetchCampaignMonitorInterests',
          required: false,
          allowEmpty: true,
          trackBy: 'list_id',
          dataNameKey: 'list_name',
          labelKey: 'list_name',
          multiple: true,
          visibleOnEmpty: false,
        },
        {
          name: "description",
          type: "textarea",
          label: i18n.t('form.description')
        },
        {
          name: "external_source_ids",
          type: "textarea",
          label: i18n.t('form.external_source_ids'),
          tooltipName: "plan-external-sources-one",
          tooltipText: i18n.t('plan_tooltips.external_sources')
        },
      ]
    },
    subscriptions: {
      title: i18n.t('plan.pricing'),
      items: [
        {
          name: 'id',
          type: "text",
          readOnly: true,
          label: i18n.t('form.id'),
        },
        {
          name: "title",
          type: "text",
          required: true,
          label: i18n.t('form.title')
        },
        {
          name: "slug",
          type: "text",
          label: i18n.t('form.pricing_slug')
        },
        {
          name: "description",
          type: "textarea",
          required: false,
          label: i18n.t("form.description"),
        },
        {
          name: "external_source_ids",
          type: "textarea",
          required: false,
          label: i18n.t("form.external_source_ids"),
          tooltipName: "plan-external-sources-two",
          tooltipText: i18n.t('plan_tooltips.external_sources')
        },
        {
          name: "type",
          type: "select",
          required: true,
          clearable: false,
          allowEmpty: false,
          preselectFirst: true,
          options: [
            {name: "Standard", value: "standard"},
            {name: "Gift", value: "gift"},
            {name: "Multi-Seat", value: "multi-seat"},
          ],
          label: i18n.t('form.type'),
        },
        {
          name: "limit_sponsored_slots",
          type: "number",
          required: false,
          min: 1,
          max: 100,
          maxLength: 3,
          label: i18n.t('form.number_of_seats'),
          conditional: {
            field: "type",
            operator: "===",
            value: "multi-seat",
          }
        },
        {
          name: "subscriber_type",
          type: "text",
          required: false,
          label: i18n.t('subscription.user_type'),
          maxLength: 25
        },
        {
          name: "price",
          type: "number",
          required: false,
          min: 0,
          label: i18n.t('form.price'),
        },
        {
          name: "vat_percent",
          type: "number",
          required: false,
          min: 0,
          max: 100,
          maxLength: 3,
          label: i18n.t('form.vat_percent'),
        },
        {
          name: "country_vat",
          label: i18n.t('form.country_vat'),
          type: "repeater",
          assembleValues: false,
          fields: [
            {
              name: "country",
              type: "select",
              storeGetter: 'data/countries',
              storeAction: 'data/fetchCountries',
              assembleValues: true,
              clearable: false,
              label: i18n.t('form.country'),
              trackBy: 'id',
              labelKey: 'title',
              outputValue: 'id'
            },
            {
              name: "vat_percent",
              type: "number",
              required: false,
              min: 0,
              max: 100,
              maxLength: 3,
              label: i18n.t('form.vat_percent'),
            },
          ]
        },
        {
          name: "is_applied_vat",
          type: "switch",
          label: i18n.t('form.apply_vat'),
          title: i18n.t('global.yes'),
          titleFalse: i18n.t('global.no')
        },
        {
          name: "period",
          type: "select",
          required: true,
          clearable: false,
          allowEmpty: false,
          preselectFirst: true,
          options: [
            {name: "1 day", value: "1 day"},
            {name: "3 days", value: "3 day"},
            {name: "5 days", value: "5 day"},
            {name: "1 week", value: "1 week"},
            {name: "2 weeks", value: "2 week"},
            {name: "3 weeks", value: "3 week"},
            {name: "1 month", value: "1 month"},
            {name: "2 months", value: "2 month"},
            {name: "3 months", value: "3 month"},
            {name: "6 months", value: "6 month"},
            {name: "1 year", value: "1 year"},
            {name: "2 years", value: "2 year"},
            {name: "3 years", value: "3 year"},
            {name: "4 years", value: "4 year"},
            {name: "5 years", value: "5 year"},
            {name: "100 years", value: "100 year"}
          ],
          label: i18n.t('form.period'),
        },
        {
          name: "trial_period",
          type: "select",
          required: false,
          allowEmpty: true,
          trackBy: 'value',
          options: [
            {name: "1 day", value: "1 day"},
            {name: "3 days", value: "3 day"},
            {name: "5 days", value: "5 day"},
            {name: "1 week", value: "1 week"},
            {name: "2 weeks", value: "2 week"},
            {name: "3 weeks", value: "3 week"},
            {name: "1 month", value: "1 month"},
            {name: "2 months", value: "2 month"},
            {name: "3 months", value: "3 month"},
            {name: "6 months", value: "6 month"},
            {name: "1 year", value: "1 year"},
            {name: "2 years", value: "2 year"},
            {name: "3 years", value: "3 year"},
            {name: "4 years", value: "4 year"},
            {name: "5 years", value: "5 year"},
            {name: "100 years", value: "100 year"}
          ],
          label: i18n.t('form.trial_period'),
        },
        {
          name: "trial_price",
          type: "number",
          required: false,
          min: 0,
          label: i18n.t('form.trial_price'),
          conditional: {
            field: "trial_period",
            operator: "!==",
            value: null,
          }
        },
        {
          name: "trial_iterations",
          type: "number",
          required: false,
          min: 1,
          label: i18n.t('form.trial_iterations'),
          conditional: {
            field: "trial_period",
            operator: "!==",
            value: null,
          }
        },
        {
          name: "active",
          type: "switch",
          label: i18n.t('form.active'),
          title: i18n.t('global.yes'),
          titleFalse: i18n.t('global.no')
        },
        {
          name: "public",
          type: "switch",
          label: i18n.t('form.public'),
          title: i18n.t('global.yes'),
          titleFalse: i18n.t('global.no')
        },
        {
          name: "once",
          type: "switch",
          label: i18n.t('form.once'),
          title: i18n.t('global.yes'),
          titleFalse: i18n.t('global.no')
        },
        {
          name: "is_allowed_upgrade_price",
          type: "switch",
          label: i18n.t('form.upgrade_price'),
          title: i18n.t('global.yes'),
          titleFalse: i18n.t('global.no'),
          tooltipName: "plan-upgrade-price",
          tooltipText: i18n.t('plan_tooltips.upgrade_price')
        },
        {
          name: "is_allowed_autorenew",
          type: "switch",
          label: i18n.t('form.autorenew'),
          title: i18n.t('global.yes'),
          titleFalse: i18n.t('global.no')
        },
        {
          name: "next_subscription",
          type: "select",
          storeGetter: 'data/plans',
          storeAction: 'data/fetchPlans',
          groupValues: 'subscriptions',
          groupLabel: 'title',
          assembleValues: true,
          main: false,
          label: i18n.t('form.next_subscription'),
          multiple: false,
          trackBy: 'id',
          labelKey: 'title',
          conditional: {
            field: "is_allowed_autorenew",
            operator: "===",
            value: false
          }
        },
        {
          name: "downgrade_subscription",
          type: "select",
          storeGetter: 'data/plans',
          storeAction: 'data/fetchPlans',
          groupValues: 'subscriptions',
          groupLabel: 'title',
          assembleValues: true,
          main: false,
          label: i18n.t('form.downgrade_subscription'),
          multiple: false,
          trackBy: 'id',
          labelKey: 'title',
        },
      ]
    }
  };

export default fields
